export default __webpack_public_path__ + "static/media/mp-pix.2b9427eb.svg";